import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useMemo } from "react";
import { clientAdmin } from "../../../Constants";
import { useGetFilteredUsersQuery } from "../../../redux/User/userApi";
import PopoverSelect from "../../../shared/components/PopoverSelect/PopoverSelect";
import { userAccess } from "../../../utils/CommonFunction";

type Props = {
  startDate: moment.Moment;
  endDate: moment.Moment;
  goToNextWeek: () => void;
  goToPrevWeek: () => void;
  goToThisWeek: () => void;
  loadingSlot: boolean;
  clientId: number;
  hiringManager?: string | number;
  setHiringManager?: (value: string | number) => void;
  slotLoading?: boolean;
};

export const TimeGridHeader = ({
  endDate,
  goToNextWeek,
  goToPrevWeek,
  goToThisWeek,
  startDate,
  loadingSlot,
  clientId,
  setHiringManager = () => {},
  slotLoading = false,
  hiringManager = "",
}: Props) => {
  const { data: clientUserList } = useGetFilteredUsersQuery({
    clientId: clientId,
    pageNumber: 0,
    pageSize: 50,
    roles: [clientAdmin].concat(["Employer", "Employer_Hiring_Manager"]),
    disabled: true,
    searchValue: "",
  });

  const memoizedClientManagerList = useMemo(() => {
    if (clientUserList?.data) {
      const userList = clientUserList?.data.users
        .filter((el) => el.isActive && el.isRegistered)
        .map((clientUser) => ({
          name:
            userAccess().userId === clientUser.userId
              ? "Myself"
              : clientUser.userName,
          value: clientUser.userId.toString(),
        }));
      userList.sort(
        (a, b) =>
          a.name.toLowerCase().charCodeAt(0) -
          b.name.toLowerCase().charCodeAt(0),
      );
      return userList;
    }
    return [];
  }, [clientUserList]);
  return (
    <Grid container item justifyContent={"space-between"} alignItems={"center"}>
      <Grid container gap={2} alignItems={"center"} item xs={6}>
        <IconButton onClick={goToPrevWeek}>
          <NavigateBefore></NavigateBefore>
        </IconButton>
        <Typography variant="body1">
          {`${moment(startDate).format("MM-DD-yyyy")} to ${moment(endDate).format("MM-DD-yyyy")}`}
        </Typography>
        <IconButton onClick={goToNextWeek}>
          <NavigateNext></NavigateNext>
        </IconButton>
        {moment().isBetween(startDate, endDate, null, "[]") ? null : (
          <Button variant={"outlined"} onClick={goToThisWeek}>
            Today
          </Button>
        )}
        {slotLoading && (
          <>
            <Typography variant="body1" color="textSecondary">
              Loading...
            </Typography>
            <CircularProgress size={24} sx={{ ml: 2 }} />
          </>
        )}
      </Grid>
      <Grid
        container
        alignItems={"center"}
        item
        xs={6}
        justifyContent={"flex-end"}
      >
        {clientId !== 0 && (
          <PopoverSelect
            onChange={setHiringManager}
            options={memoizedClientManagerList}
            showAll
            buttonText="All Hiring Managers"
            value={hiringManager}
          />
        )}
      </Grid>
    </Grid>
  );
};
